import { get, post, put, del } from '../../../../GlobalModules/Utility/Http'
import {
  getInvoices,
  mapBillToList,
  mapProductsForInvoice,
  createInvoice
} from '../Model/InvoiceModel'

export const getInvoicesApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        field: item.field,
        sort: item.sort
      }))
    } else {
      filtersObj.sort = [
        {
          field: 'invoice_number',
          sort: 'desc'
        }
      ]
    }

    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}invoice`,
      queryParams
    )
    return getInvoices(response)
  } catch (error) {
    throw error
  }
}

export const loadBillToListApi = async (keywords, type) => {
  try {
    const normalizedType = String(type || 'CUSTOMER').toUpperCase()

    const body = {
      keywords: keywords,
      type: normalizedType,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_bill_to_list`,
      body
    )
    return mapBillToList(response)
  } catch (error) {
    return mapBillToList(error?.response || {})
  }
}

export const loadProductsForInvoiceApi = async (
  keywords,
  billToType,
  entitySlack
) => {
  try {
    const trimmed = String(keywords || '').trim()

    // Don't make API call if keywords is empty or just whitespace
    if (!trimmed || trimmed.length === 0) {
      return { success: true, data: [] }
    }

    const requestBody = {
      keywords: trimmed,
      // API expects "supplier" key; reuse until separate endpoint is provided
      supplier: entitySlack,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_product_for_po`,
      requestBody
    )
    return mapProductsForInvoice(response)
  } catch (error) {
    return mapProductsForInvoice(error?.response || {})
  }
}

export const createInvoiceApi = async (data) => {
  try {
    // Add store_id to the payload only if not already present
    const payload = {
      ...data,
      store_id: data.store_id || localStorage.getItem('store_id')
    }
    const response = await post(`${process.env.EXTENDED_URL}invoice`, payload)
    return createInvoice(response)
  } catch (error) {
    return createInvoice(error?.response || {})
  }
}

export const updateInvoiceApi = async (slack, data) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}invoice/${slack}`,
      data
    )
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

export const exportInvoicesApi = async (data) => {
  try {
    const requestBody = {}
    let queryParams = {};

    requestBody.from_created_date =
      data.from_created_date ||
      new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split('T')[0]
    requestBody.to_created_date =
      data.to_created_date || new Date().toISOString().split('T')[0]
    if (
      data.status !== undefined &&
      data.status !== null &&
      data.status !== ''
    ) {
      requestBody.status = String(data.status)
    }
    requestBody.store_id = localStorage.getItem('store_id');
    requestBody.download = "xlsx";

    queryParams.filters = JSON.stringify(requestBody);

    // Attempt report export with base64/URL handling similar to PO
    try {
      const resp = await get(
        `${process.env.EXTENDED_URL}report/invoice`,
        queryParams
      )
      if (resp?.data?.success && resp.data.link) {
        if (resp.data.link.startsWith('data:')) {
          const base64Data = resp.data.link.split(',')[1]
          const binaryData = atob(base64Data)
          const bytes = new Uint8Array(binaryData.length)
          for (let i = 0; i < binaryData.length; i++)
            bytes[i] = binaryData.charCodeAt(i)
          return {
            success: true,
            data: bytes.buffer,
            message: 'Export completed - converted from base64',
            filename: resp.data.filename || 'invoices_export.xlsx'
          }
        }
        return {
          success: true,
          data: resp.data.link,
          message: 'Export completed - file URL provided',
          isFileUrl: true,
          filename: resp.data.filename || 'invoices_export.xlsx'
        }
      }
      // Fallback: return raw data (might be binary already)
      return {
        success: true,
        data: resp.data,
        filename: 'invoices_export.xlsx'
      }
    } catch (e) {
      // propagate to caller; they will fallback to CSV
      throw e
    }
  } catch (error) {
    console.error('Error exporting invoices:', error)
    return { success: false, message: 'Export failed' }
  }
}

export const getInvoiceApi = async (slack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}invoice/${slack}`)
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, data: null, message: response?.data?.message }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message
    }
  }
}

export const updateInvoiceStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}invoice/status/${slack}`,
      { status }
    )
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

export const deleteInvoiceApi = async (slack) => {
  try {
    // Use relative API path to match other modules' delete behaviour
    const response = await del(`api/v1/invoice/${slack}`)
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

// Record Payment helpers
export const getPendingPaymentApi = async (slack) => {
  try {
    const response = await get(
      `${process.env.EXTENDED_URL}invoice/pending_payment/${slack}`
    )
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

export const createTransactionApi = async (payload) => {
  try {
    const response = await post(
      `${process.env.EXTENDED_URL}transaction`,
      payload
    )
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

export const getInvoiceTransactionsApi = async (invoiceSlack) => {
  try {
    // Query unified transaction list with filters scoped to this invoice
    const filtersObj = {
      limit: 50,
      offset: 0,
      bill_to: 'INVOICE',
      bill_to_slack: invoiceSlack,
      store_id: localStorage.getItem('store_id')
    }
    const queryParams = {
      filters: JSON.stringify(filtersObj)
    }
    const resp = await get(
      `${process.env.EXTENDED_URL}transaction`,
      queryParams
    )
    const list = resp?.data?.data || []
    const mapped = Array.isArray(list)
      ? list.map((t) => ({
          id: t.id || t.slack,
          slack: t.slack || t.id,
          transaction_date:
            t.transaction_date || t.date || t.created_at || t.createdAt,
          type: (t.transaction_type || t.type || t.value_constant || '')
            .toString()
            .toUpperCase(),
          type_label:
            t.transaction_type_data?.label || t.type_label || t.label || '',
          account_label:
            t.account_data?.label ||
            t.account?.label ||
            t.account_label ||
            t.account,
          account_slack:
            t.account_data?.slack ||
            t.account?.slack ||
            t.account_slack ||
            t.account_id,
          payment_method_label:
            t.payment_method_data?.label ||
            t.payment_method?.label ||
            t.payment_method_label ||
            t.payment_method ||
            t.payment,
          payment_method_slack:
            t.payment_method_data?.slack ||
            t.payment_method?.slack ||
            t.payment_method_slack ||
            t.payment_method_id,
          amount: t.amount || t.transaction_amount || 0,
          notes: t.notes || ''
        }))
      : []
    return { success: true, data: mapped }
  } catch (e) {
    return { success: false, data: [] }
  }
}

// Load Accounts and Payment Methods via generic API
const extractResourceArray = (resp, resourceKey) => {
  if (!resp || !resp.data) return []
  const data = resp.data.data || resp.data
  const nested = Array.isArray(data)
    ? data[0]?.[`${resourceKey}_data`]
    : data?.[`${resourceKey}_data`]
  if (Array.isArray(nested)) return nested
  if (Array.isArray(data)) return data
  return []
}

export const loadAccountsApi = async () => {
  try {
    const storeId = localStorage.getItem('store_id')
    const queryParams = {
      filters: JSON.stringify({ store_id: storeId })
    }
    const resp = await get(
      `${process.env.EXTENDED_URL}account/list`,
      queryParams
    )
    const arr = resp?.data?.data || []
    const mapped = arr.map((a) => ({ slack: a.slack, label: a.label }))
    return { success: true, data: mapped }
  } catch (e) {
    return { success: false, data: [] }
  }
}

export const loadPaymentMethodsApi = async () => {
  try {
    const storeId = localStorage.getItem('store_id')
    const queryParams = {
      filters: JSON.stringify({ store_id: storeId })
    }
    const resp = await get(
      `${process.env.EXTENDED_URL}payment_method`,
      queryParams
    )
    const arr = resp?.data?.data || []
    const mapped = arr.map((m) => ({ slack: m.slack, label: m.label }))
    return { success: true, data: mapped }
  } catch (e) {
    return { success: false, data: [] }
  }
}

export const loadTransactionTypesApi = async () => {
  try {
    const resp = await get(`${process.env.EXTENDED_URL}master_transaction_type`)
    const arr = resp?.data?.data || []
    const mapped = arr
      .map((t) => {
        const rawValue =
          t.transaction_type_constant ||
          t.value_constant ||
          t.value ||
          t.key ||
          ''
        const value = String(rawValue).toUpperCase()
        const label = t.label || rawValue || ''
        return value ? { value, label } : null
      })
      .filter(Boolean)
    return { success: true, data: mapped }
  } catch (e) {
    return { success: false, data: [] }
  }
}
